import { atom } from 'jotai';
import { unwrap } from 'jotai/utils';
import { objSnakeToCamel } from '@/utils/queries';
import { rawFilteredPlayerInfoAtom } from '../queries/players';

export const playerInfoAtom = atom(async get => {
  const playerInfo = await get(rawFilteredPlayerInfoAtom);
  if (!playerInfo) return null;

  return objSnakeToCamel(playerInfo);
});

export const unwrappedPlayerInfoAtom = unwrap(playerInfoAtom, prev => prev || undefined);

export const selectedPlayerNameAtom = atom(async get => {
  const playerInfo = await get(rawFilteredPlayerInfoAtom);
  if (!playerInfo) return '';

  return playerInfo.display_name;
});

export const unwrappedSelectedPlayerNameAtom = unwrap(selectedPlayerNameAtom, prev => prev || '');
